import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate } from 'react-intl';

const propTypes = {
    date: PropTypes.string,
};

function Date({ date = null }) {
    return date !== null ? (
        <FormattedDate
            value={date}
            day="numeric"
            month="long"
            year="numeric"
            hour="numeric"
            minute="numeric"
        />
    ) : null;
}

Date.propTypes = propTypes;

export default Date;
